import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { AdminModule } from '@/store/modules/admin';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.otpForm = {
      otp: '',
      mobileNumber: '',
      hash: ''
    };
    this.otpRules = {
      otp: [{
        required: true,
        message: 'Please enter OTP',
        trigger: 'blur'
      }]
    };
    this.loading = false;
  }
  verifyOtp() {
    this.$refs.otpForm.validate(async valid => {
      if (valid) {
        this.loading = true;
        try {
          // Verify the OTP by calling the verifyOtp method in AdminModule
          await AdminModule.verifyOtp({
            mobileNumber: this.$route.query.mobileNumber.toString(),
            hash: this.$route.query.hash.toString(),
            otp: this.otpForm.otp
          });
          // Navigate to the dashboard after successful OTP verification
          this.$router.push({
            path: '/dashboard'
          });
        } catch (error) {
          this.loading = false;
        }
      } else {
        return false;
      }
    });
  }
};
default_1 = __decorate([Component({
  name: 'VerifyOtp'
})], default_1);
export default default_1;